import { render } from "./watermark-zoom.vue?vue&type=template&id=684cb5d6&scoped=true&ts=true"
import script from "./watermark-zoom.vue?vue&type=script&lang=ts"
export * from "./watermark-zoom.vue?vue&type=script&lang=ts"

import "./watermark-zoom.vue?vue&type=style&index=0&id=684cb5d6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684cb5d6"]])

export default __exports__